// extracted by mini-css-extract-plugin
export default {"fulfilled":"styles_fulfilled__RkMP8","image":"styles_image__fJAvN","mirrored":"styles_mirrored__ctQ0y","title":"styles_title__BKgNV","fulfilledIcon":"styles_fulfilledIcon__GsLp3"};